import React, { useContext, useState} from 'react';
import { Modal } from 'react-bootstrap';
import constants from '../../constants/constants';
import useMakeSession from '../../hooks/useMakeSession';
import { ConfigContext } from "../../providers/ConfigContext";
import styles from './ExternalLogin.module.scss';

const ExternalLogin = (props: any) => {
  const { logInUrl } = useContext(ConfigContext);
  const signInUrl = logInUrl + constants.login;
  const [show, setShow] = useState(true);
  const [mySession] = useMakeSession();
  const env = process.env.REACT_APP_BF;

  window.addEventListener("message", (event:any) => {
    callbackLogin(event);
  }, true);

 // creates cookie after modal login
 const createCookie = async () =>{
  const { data, error } = await mySession(props.fairId);
  if (error){
    localStorage.removeItem("loggedIn");
    window.location.replace(`${env}${constants.bf}`);
  } else if (data != null) {
    localStorage.loggedIn = true;
    const info = {
      school: data.school.name,  
      startDate: data.fair.deliveryDate,
      endDate: data.fair.pickupDate,
      id: data.fair.id,

      ccSales: data.sales.cc,
      ewalletSales: data.sales.ewallet,
      totalSales: data.sales.total,
      stfSales: data.sales.stf,
    }
    props.handleInfo(info);
  }
}

 const callbackLogin = (event: MessageEvent) => {
  if (event && event.origin === logInUrl) {
    const {status, data} = JSON.parse(event.data);
  if (status === 'SUCCESS') {
      localStorage.loggedIn = true;
      setShow(false);
      createCookie();
      console.log('logged in');
    } else if (status === 'REDIRECT') {
      console.log(status, data);
    } else if (status === 'RESET') {
      console.log(status, data);
      //we do nothing here bc reset link will come through email
    }
  }
}

  return(
    <div className={styles.ExternalLogin} data-testid="ExternalLogin">
      <Modal show={show}>
        <div className={styles.extLogin}>
          <iframe id="loginModal" src={signInUrl} title="Login Modal"/>
        </div>
      </Modal>
    </div>
  )

}

export default ExternalLogin;
